import React from 'react';

const BanterHeading = (props) => {

	const Align = (props.align === 'left' ? 'point-left' : 'point-right');
	const Theme = (props.theme === 'dark' ? 'dark' : 'light');

	return (
		<div className="banter-heading">
			<div className={`overflow ${Align} ${Theme}`}>
				<div className="banter-inner">
					<h2 dangerouslySetInnerHTML={{__html: props.title}} />
				</div>
			</div>
		</div>
	);

};

export default BanterHeading;


// WEBPACK FOOTER //
// ./resources/assets/js/elements/BanterHeading.js